var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Voting } from "common/Voting";
import { Id } from "core/utils";
import { HeroBlock, ExtraBlock, HighlightsBlock, RecentVideosBlock, PopularProgramsBlock, NewsPlaylist, TeamsBlock, SeasonBlock, ContentBanner, EmbedBlock, TicketBlock, } from "./blocks";
var group1 = [
    HeroBlock.block,
    Voting.block,
    HighlightsBlock.block(Id.component.contentCollection.highlights, "highlights"),
    TicketBlock.block,
    NewsPlaylist.block,
];
var group2 = [
    TeamsBlock.block,
    ExtraBlock.block(Id.component.contentCollection.extra, "extra"),
    HighlightsBlock.block(Id.component.contentCollection.highlightsTwo, "highlights2"),
];
var groupExtra = [
    ExtraBlock.block(Id.component.contentCollection.extraTwo, "extra2"),
    ExtraBlock.block(Id.component.contentCollection.extraThree, "extra3"),
    ExtraBlock.block(Id.component.contentCollection.extraFour, "extra4"),
    ExtraBlock.block(Id.component.contentCollection.extraFive, "extra5"),
    ExtraBlock.block(Id.component.contentCollection.extraSix, "extra6"),
    ExtraBlock.block(Id.component.contentCollection.extraSeven, "extra7"),
    ExtraBlock.block(Id.component.contentCollection.extraEight, "extra8"),
];
var Default = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], group1, true), [
    ContentBanner.block,
    EmbedBlock.block,
    RecentVideosBlock.block
], false), group2, true), groupExtra, true), [
    SeasonBlock.block,
    PopularProgramsBlock.block,
], false);
var Vtmgo = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], group1, true), [
    SeasonBlock.block,
    RecentVideosBlock.block,
    ContentBanner.block,
    EmbedBlock.block
], false), group2, true), groupExtra, true), [
    PopularProgramsBlock.block,
], false);
var Totz = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], group1, true), [
    ContentBanner.block,
    RecentVideosBlock.block
], false), group2, true), groupExtra, true), [
    SeasonBlock.block,
    PopularProgramsBlock.block,
    EmbedBlock.block,
], false);
var CodeVanCoppens = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], group1, true), [
    ContentBanner.block,
    RecentVideosBlock.block
], false), group2, true), groupExtra, true), [
    EmbedBlock.block,
    SeasonBlock.block,
    PopularProgramsBlock.block,
], false);
var TheVoiceVanVlaanderen = __spreadArray(__spreadArray(__spreadArray([
    HeroBlock.block,
    EmbedBlock.block,
    HighlightsBlock.block(Id.component.contentCollection.highlights, "highlights"),
    TicketBlock.block,
    NewsPlaylist.block,
    ContentBanner.block,
    RecentVideosBlock.block
], group2, true), groupExtra, true), [
    SeasonBlock.block,
    PopularProgramsBlock.block,
], false);
var FullScreenEmbed = [EmbedBlock.block];
export var BlockLists = {
    Default: Default,
    Vtmgo: Vtmgo,
    Totz: Totz,
    CodeVanCoppens: CodeVanCoppens,
    TheVoiceVanVlaanderen: TheVoiceVanVlaanderen,
    FullScreenEmbed: FullScreenEmbed,
};
